// types of api data
export interface Employee {
  employee_name: string;
  join_date: string; // "DD/MM/YYYY"
  gender: string;
  band: string;
  designation: string;
  department: string;
  location: string;
}

export interface Salary {
  id: number;
  s_no: number;
  employee_code: string | null;
  working_days: number;
  lwp_days: number;
  present_days: number;
  payment_status: string | null;
  salary_month: number;
  salary_year: number;
  created_at: string | null; // ISO date string
  bank_name: string | null;
  bank_account: string | null;
  pan: string | null;
  pf_account: string | null;
  uan_number: string | null;
  PaidVariablePay: string | null;
  TotalVariablePay: string | null;
  PaidBonus: string | null;
  TotalBonus: string | null;
  incomeTaxActual: string | null;
  incomeTaxArrear: string | null;
  incomeTaxTotal: string | null;
  incomeTaxYTD: string | null;

  // Earnings
  arrears_days: string | null;
  salary: string | null;
  basic: string | null;
  hra: string | null;
  child_edu: string | null;
  personal_allowance: string | null;
  gross_salary: string | null;

  // Paid components
  paid_basic: string | null;
  paid_hra: string | null;
  paid_child_edu: string | null;
  paid_personal: string | null;
  leave_encashment: string | null;
  bonus: string | null;
  variable_pay: string | null;
  prev_month_arrears: string | null;
  arrear: string | null;
  paid_gross: string | null;

  // arear
  basic_arrear: string | null;
  hra_arrear: string | null;
  child_edu_arrear: string | null;
  personal_arrear: string | null;

  // total
  total_earning: string | null;
  total_earning_ytd: string | null;
  total_basic: string | null;
  total_hra: string | null;
  total_children: string | null;
  total_personal_allowance: string | null;
  total_pf: string | null;

  // YTD
  basic_ytd: string | null;
  hra_ytd: string | null;
  child_edu_ytd: string | null;
  personal_allowance_ytd: string | null;
  other_deduction_ytd: string | null;

  // Deductions
  epf: string | null;
  epf_ytd: string | null;
  epf_arrear: string | null;
  esic: string | null;
  medical_insurance: string | null;
  medical_insurance_arrear: string | null;
  total_medical_ins: string | null;
  medical_insurance_ytd: string | null;
  other_deduction_arrear: string | null;

  advance: string | null;
  fnf_deduction: string | null;
  other_deduction: string | null;
  tds: string | null;
  total_deduction: string | null;
  net_payable: string | null;
  loan: string | null;
}

export interface PayslipDataTypes {
  employee: Employee;
  salary: Salary;
}

export const payslipEmpty: PayslipDataTypes = {
  employee: {
    employee_name: "",
    join_date: "",
    gender: "",
    band: "",
    designation: "",
    department: "",
    location: "",
  },

  salary: {
    id: 0,
    s_no: 0,
    employee_code: "",
    working_days: 0,
    lwp_days: 0,
    present_days: 0,
    payment_status: null,
    salary_month: 0,
    salary_year: 0,
    created_at: "",
    bank_name: "",
    bank_account: "",
    pan: "",
    pf_account: "",
    uan_number: "",
    PaidVariablePay: "",
    TotalVariablePay: "",
    PaidBonus: "",
    TotalBonus: "",
    incomeTaxActual: "",
    incomeTaxArrear: "",
    incomeTaxTotal: "",
    incomeTaxYTD: "",

    // Earnings
    arrears_days: "",
    salary: "",
    basic: "",
    hra: "",
    child_edu: "",
    personal_allowance: "",
    gross_salary: "",

    // Paid components
    paid_basic: "",
    paid_hra: "",
    paid_child_edu: "",
    paid_personal: "",
    leave_encashment: "",
    bonus: "",
    variable_pay: "",
    prev_month_arrears: "",
    arrear: "",
    paid_gross: "",

    // arear
    basic_arrear: "",
    hra_arrear: "",
    child_edu_arrear: "",
    personal_arrear: "",

    // total
    total_earning: "",
    total_earning_ytd: "",
    total_basic: "",
    total_hra: "",
    total_children: "",
    total_personal_allowance: "",
    total_pf: "",

    // YTD
    basic_ytd: "",
    hra_ytd: "",
    child_edu_ytd: "",
    personal_allowance_ytd: "",
    other_deduction_ytd: "",

    // Deductions
    epf: "",
    epf_ytd: "",
    epf_arrear: "",
    esic: "",
    medical_insurance: "",
    medical_insurance_arrear: "",
    total_medical_ins: "",
    medical_insurance_ytd: "",
    other_deduction_arrear: "",

    advance: "",
    fnf_deduction: "",
    other_deduction: "",
    tds: "",
    total_deduction: "",
    net_payable: "",
    loan: "",
  },
};

const monthsArray = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const formattedAmount = (val: string | number | null) => {
  if (val === 0) return 0;
  if (!val || (typeof val === "string" && !val.trim())) return "-";
  return Number(val).toLocaleString("en-IN");
};

export const buildPage1 = (f: PayslipDataTypes) => {
  const empData = f.employee || {};
  const salaryData = f.salary || {};

  return `<div style="font-size:14px;padding:48px 56px;min-height:297mm;box-sizing:border-box;color:#111;">
  
  <!-- Header -->
  <div style="margin-left:0; display:flex; justify-content:space-between; align-items:center;">
    <div>
      <h2 style="margin:0;">Team1 Consulting Private Limited</h2>
      <p style="margin-top:8px; margin-left:5px"><strong>Payslip for ${monthsArray[salaryData.salary_month - 1]} ${salaryData.salary_year}</strong></p>
    </div>
    <div>
      <img src="/assets/img/team1-consultancy1.png" style="max-height:60px;" />
    </div>
  </div>

  <!-- Employee Details -->
  <div style="display:flex; margin-top:18px;">
    
    <!-- Left -->
    <div style="width:50%;font-size:0.78rem">
      <p style="margin:13px auto;"><strong>Employee ID:</strong> ${salaryData?.employee_code || "-"}</p>
      <p style="margin:13px auto;"><strong>Name:</strong> ${empData?.employee_name || "-"}</p>
      <p style="margin:13px auto;"><strong>Gender:</strong> ${empData?.gender || "-"}</p>
      <p style="margin:13px auto;"><strong>Designation:</strong> ${empData?.designation || "-"}</p>
      <p style="margin:13px auto;"><strong>Location:</strong> ${empData?.location || "-"}</p>
      <p style="margin:13px auto;"><strong>Department:</strong> ${empData?.department || "-"}</p>
    <!-- <p style="margin:13px auto;"><strong>Category:</strong> ${empData?.band || "-"}</p> -->
      <p style="margin:13px auto;"><strong>Present Days:</strong> ${salaryData?.present_days || "-"}</p>
      <p style="margin:13px auto;"><strong>LWP Days:</strong> ${salaryData?.lwp_days || "-"}</p>
    </div>

    <!-- Right -->
    <div style="width:50%;font-size:0.78rem">
      <p style="margin:13px auto;"><strong>Date of Joining:</strong> ${empData?.join_date || "-"}</p>
      <p style="margin:13px auto;"><strong>Bank Name:</strong> ${salaryData?.bank_name || "-"}</p>
      <p style="margin:13px auto;"><strong>Bank Account No:</strong> ${salaryData?.bank_account || "-"}</p>
      <p style="margin:13px auto;"><strong>PAN No:</strong> ${salaryData?.pan || "-"}</p>
      <p style="margin:13px auto;"><strong>PF Account No:</strong> ${salaryData?.pf_account || "-"}</p>
      <p style="margin:13px auto;"><strong>UAN No:</strong> ${salaryData?.uan_number || "-"}</p>
      <p style="margin:13px auto;"><strong>Arrears Days:</strong> ${salaryData?.arrears_days || "-"}</p>
    </div>
  </div>

  <!-- Allowances Table -->
  <div style="width:100%;overflow-x:auto;display:block;margin-top:8px;">
  <table style="min-width:600px;width:max-content;max-width:750px;border-collapse:collapse;">
    <thead>
      <tr style="font-size:14px; font-weight:600;">
        <th style="padding:5px 0px; text-align:left;width:180px; padding-bottom:11px;">Allowances (A)</th>
      </tr>
      <tr style="background:#f3f4f6">
       <th style="padding:5px 10px; text-align:left;min-width:190px;">Component</th>
        <th style="padding:5px 0px; text-align:right;min-width:90px">Actual</th>
        <th style="padding:5px 0px; text-align:right;min-width:90px">Paid</th>
        <th style="padding:5px 0px; text-align:right;min-width:90px">Arrear</th>
        <th style="padding:5px 0px; text-align:right;min-width:90px">Total</th>
        <th style="padding:5px 10px; text-align:right;min-width:110px">YTD</th>
      </tr>
    </thead>

  <tbody style="font-size:0.78rem;">
    <tr>
      <td style="padding:5px 10px; margin:7px auto;">Basic</td>
      <td style="padding:5px 0px; margin:7px auto; text-align:right;">${formattedAmount(salaryData?.basic)}</td>
      <td style="padding:5px 0px; margin:7px auto; text-align:right;">${formattedAmount(salaryData?.paid_basic)}</td>
      <td style="padding:5px 0px; margin:7px auto; text-align:right;">${formattedAmount(salaryData?.basic_arrear)}</td>
      <td style="padding:5px 0px; margin:7px auto; text-align:right;">${formattedAmount(salaryData?.total_basic)}</td>
      <td style="padding:5px 10px; margin:7px auto; text-align:right;">${formattedAmount(salaryData?.basic_ytd)}</td>
    </tr>

    <tr>
      <td style="padding:5px 10px; margin:7px auto;">House Rent Allowance</td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.hra)}</td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.paid_hra)}</td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.hra_arrear)}</td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.total_hra)}</td>
      <td style="padding:5px 10px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.hra_ytd)}</td>
    </tr>

    <tr>
      <td style="padding:5px 10px; margin:7px auto;">Special Allowance</td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.personal_allowance)}</td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.paid_personal)}</td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.personal_arrear)}</td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.total_personal_allowance)}</td>
      <td style="padding:5px 10px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.personal_allowance_ytd)}</td>
    </tr>

    <tr>
      <td style="padding:5px 10px; margin:7px auto;">Children Education Allowance</td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.child_edu)}</td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.paid_child_edu)}</td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.child_edu_arrear)}</td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.total_children)}</td>
      <td style="padding:5px 10px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.child_edu_ytd)}</td>
    </tr>

    <tr>
      <td style="padding:5px 10px; margin:7px auto;">Prev. Mth. Arrears</td>
      <td></td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.prev_month_arrears)}</td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.prev_month_arrears)}</td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.prev_month_arrears)}</td>
      <td style="padding:5px 10px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.prev_month_arrears)}</td>
    </tr>

    <tr style="font-weight:700;">
      <td style="padding:5px 10px; margin:7px auto;">Total Earnings</td>
      <td></td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.paid_gross)}</td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.arrear)}</td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.total_earning)}</td>
      <td style="padding:5px 10px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.total_earning_ytd)}</td>
    </tr>

    <tr>
      <td style="padding:7px 0;"></td>
    </tr>
    
    <tr style="background:#f3f4f6;font-size:14px">
      <td colspan="6" style="padding:5px 10px; text-align:left;width:140px;font-weight:700">Other Earnings (C)</td>
    </tr>

    <!-- <tr>
      <td style="padding:5px 10px;margin:7px auto;">Leave Encashment</td>
      <td colspan="3"></td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.leave_encashment)}</td>
      <td></td>
    </tr> -->

    <tr>
      <td style="padding:5px 10px;margin:7px auto;">Variable Pay</td>
      <td></td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.PaidVariablePay)}</td>
      <td></td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.TotalVariablePay)}</td>
      <td></td>
    </tr>
    <tr>
      <td style="padding:5px 10px;margin:7px auto;">Bonus</td>
      <td></td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.PaidBonus)}</td>
      <td></td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.TotalBonus)}</td>
      <td></td>
    </tr>

    <tr style="font-weight: 700;">
      <td style="padding:5px 10px;margin:7px auto;">Net Earnings(E=A+C)</td>
      <td colspan="3"></td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.total_earning)}</td>
      <td></td>
    </tr>
    <tr style="font-weight: 700;">
      <td style="padding:5px 10px;margin:7px auto;">Net Pay(E-F)</td>
      <td colspan="3"></td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.net_payable)}</td>
      <td></td>
    </tr>
  </tbody>
</table>
</div>

<!-- Deductions Table -->
<div style="width:100%;overflow-x:auto;display:block;margin-top:14px;">
<table style="min-width:600px;width:max-content;max-width:750px;border-collapse:collapse;">
  <thead>
    <tr style="font-size:14px; font-weight:600;">
      <th style="padding:5px 0px; text-align:left;width:180px; padding-bottom:11px;">Deductions (B)</th>
    </tr>
    <tr style="background:#f3f4f6;">
        <th style="padding:5px 10px; text-align:left;min-width:190px;">Component</th>
        <th style="padding:5px 0px; text-align:right;min-width:90px">Actual</th>
        <th style="padding:5px 0px; text-align:right;min-width:90px"></th>
        <th style="padding:5px 0px; text-align:right;min-width:90px">Arrear</th>
        <th style="padding:5px 0px; text-align:right;min-width:90px">Total</th>
        <th style="padding:5px 10px; text-align:right;min-width:110px">YTD</th>
      </tr>
    </tr>
  </thead>

  <tbody style="font-size:0.78rem;">
    <tr>
      <td style="padding:5px 10px; margin:7px auto;text-align:left;">PF (Employee Contribution)</td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.epf)}</td>
      <td></td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.epf_arrear)}</td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.total_pf)}</td>
      <td style="padding:5px 10px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.epf_ytd)}</td>
    </tr>
    <tr>
      <td style="padding:5px 10px; margin:7px auto;text-align:left;">Income Tax</td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.incomeTaxActual)}</td>
      <td></td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.incomeTaxArrear)}</td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.incomeTaxTotal)}</td>
      <td style="padding:5px 10px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.incomeTaxYTD)}</td>
    </tr>

    <!-- <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.total_medical_ins)}</td> -->
    <!-- <tr>
      <td style="padding:5px 10px; margin:7px auto;text-align:left;">Medical Deduction</td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.medical_insurance)}</td>
      <td></td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.medical_insurance_arrear)}</td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.medical_insurance)}</td>
      <td style="padding:5px 10px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.medical_insurance_ytd)}</td>
    </tr> -->
    <tr>
      <td style="padding:8px 0px;margin:7px auto;">Others Deduction</td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.esic)}</td>
      <td></td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.other_deduction_arrear)}</td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.total_deduction)}</td>
      <td style="padding:5px 10px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.other_deduction_ytd)}</td>
    </tr>
  
    <tr>
      <td style="padding:7px 0;"></td>
    </tr>

    <tr style="background:#f3f4f6;font-size:14px;">
      <td colspan="6" style="padding:8px 10px; text-align:left;width:150px;font-weight:700">Other Deductions (D)</td>
    </tr>
    <tr>
      <td style="padding:5px 10px;margin:7px auto;">Loan</td>
      <td colspan="3"></td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.loan)}</td>
      <td></td>
    </tr>
    <tr>
      <td style="padding:5px 10px;margin:7px auto;">Advance</td>
      <td colspan="3"></td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.advance)}</td>
      <td></td>
    </tr>
    <tr>
      <td style="padding:5px 10px;margin:7px auto;">Medical</td>
      <td colspan="3"></td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.medical_insurance)}</td>
      <!-- <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.total_medical_ins)}</td> -->
      <td></td>
    </tr>

    <tr style="font-weight: 700;">
      <td style="padding:5px 10px;margin:7px auto;">Net Deductions(F=B+D)</td>
      <td colspan="3"></td>
      <td style="padding:5px 0px; margin:7px auto;text-align:right;">${formattedAmount(salaryData?.total_deduction)}</td>
      <td></td>
    </tr>    
  </tbody>
</table>
</div>

  <!-- Footer -->
  <p style="text-align:center; margin-top:60px; font-size:11px;">
    This is a system generated payslip
  </p>
</div>`;
};

export const download_page1 = (f: PayslipDataTypes) => {
  const empData = f.employee || {};
  const salaryData = f.salary || {};

  return `<div style="font-size:14px;padding:45px 56px 30px;min-height:297mm;box-sizing:border-box;color:#111; font-family:'Roboto', sans-serif;">
  
  <!-- Header -->
  <div style="margin-left:0; display:flex; justify-content:space-between; align-items:start;">
    <div>
      <h2 style="margin:0;">Team1 Consulting Private Limited</h2>
      <p style="margin-top:8px; margin-left:5px"><strong>Payslip for ${monthsArray[salaryData.salary_month - 1]} ${salaryData.salary_year}</strong></p>
    </div>
    <div>
      <img src="/assets/img/team1-consultancy1.png" style="max-height:60px;margin-top:-10px" />
    </div>
  </div>

  <!-- Employee Details -->
 <div style="display:flex; flex-wrap:wrap; margin-top:25px; font-size:0.76rem;">

  <!-- Row 1 -->
  <div style="width:33.33%; margin:5px 0;"><strong>Employee ID:</strong> ${salaryData?.employee_code || "-"}</div>
  <div style="width:33.33%; margin:5px 0;"><strong>Name:</strong> ${empData?.employee_name || "-"}</div>
  <div style="width:33.33%; margin:5px 0;"><strong>Gender:</strong> ${empData?.gender || "-"}</div>

  <!-- Row 2 -->
  <div style="width:33.33%; margin:5px 0;"><strong>Designation:</strong> ${empData?.designation || "-"}</div>
  <div style="width:33.33%; margin:5px 0;"><strong>Location:</strong> ${empData?.location || "-"}</div>
  <div style="width:33.33%; margin:5px 0;"><strong>Department:</strong> ${empData?.department || "-"}</div>

  <!-- Row 3 -->
  <!-- <div style="width:33.33%; margin:5px 0;"><strong>Category:</strong> ${empData?.band || "-"}</div> -->
  <div style="width:33.33%; margin:5px 0;"><strong>Date of Joining:</strong> ${empData?.join_date || "-"}</div>
  <div style="width:33.33%; margin:5px 0;"><strong>Present Days:</strong> ${salaryData?.present_days || "-"}</div>

  <!-- Row 4 -->
  <div style="width:33.33%; margin:5px 0;"><strong>Bank Name:</strong> ${salaryData?.bank_name || "-"}</div>
  <div style="width:33.33%; margin:5px 0;"><strong>Bank Account No:</strong> ${salaryData?.bank_account || "-"}</div>
  <div style="width:33.33%; margin:5px 0;"><strong>PAN No:</strong> ${salaryData?.pan || "-"}</div>

  <!-- Row 5 -->
  <div style="width:33.33%; margin:5px 0;"><strong>PF Account No:</strong> ${salaryData?.pf_account || "-"}</div>
  <div style="width:33.33%; margin:5px 0;"><strong>UAN No:</strong> ${salaryData?.uan_number || "-"}</div>
  <div style="width:33.33%; margin:5px 0;"><strong>Arrears Days:</strong> ${salaryData?.arrears_days || "-"}</div>

  <!-- Row 6 -->
  <div style="width:33.33%; margin:5px 0;"><strong>LWP Days:</strong> ${salaryData?.lwp_days || "-"}</div>

</div>

  <!-- Allowances Table -->
  <div style="width:100%;overflow-x:auto;display:block;margin-top:10px;">
  <table style="min-width:600px;width:max-content;max-width:750px;border-collapse:collapse;">
    <thead>
    <tr style="font-size:14px; font-weight:600;">
        <th style="padding:5px 0px; text-align:left;width:180px; padding-bottom:11px;">Allowances (A)</th>
      </tr>
      <tr style="background:#f3f4f6;">
        <th style="padding:5px 10px; text-align:left;min-width:190px;">Component</th>
        <th style="padding:5px 0px; text-align:right;min-width:90px">Actual</th>
        <th style="padding:5px 0px; text-align:right;min-width:90px">Paid</th>
        <th style="padding:5px 0px; text-align:right;min-width:90px">Arrear</th>
        <th style="padding:5px 0px; text-align:right;min-width:90px">Total</th>
        <th style="padding:5px 10px; text-align:right;min-width:110px">YTD</th>
      </tr>
    </thead>

  <tbody style="font-size:0.78rem;">
    <tr>
      <td style="padding:5px 10px; margin:6px auto;">Basic</td>
      <td style="padding:5px 0px; margin:6px auto; text-align:right;">${formattedAmount(salaryData?.basic)}</td>
      <td style="padding:5px 0px; margin:6px auto; text-align:right;">${formattedAmount(salaryData?.paid_basic)}</td>
      <td style="padding:5px 0px; margin:6px auto; text-align:right;">${formattedAmount(salaryData?.basic_arrear)}</td>
      <td style="padding:5px 0px; margin:6px auto; text-align:right;">${formattedAmount(salaryData?.total_basic)}</td>
      <td style="padding:5px 10px; margin:6px auto; text-align:right;">${formattedAmount(salaryData?.basic_ytd)}</td>
    </tr>

    <tr>
      <td style="padding:5px 10px; margin:6px auto;">House Rent Allowance</td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.hra)}</td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.paid_hra)}</td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.hra_arrear)}</td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.total_hra)}</td>
      <td style="padding:5px 10px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.hra_ytd)}</td>
    </tr>

    <tr>
      <td style="padding:5px 10px; margin:6px auto;">Special Allowance</td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.personal_allowance)}</td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.paid_personal)}</td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.personal_arrear)}</td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.total_personal_allowance)}</td>
      <td style="padding:5px 10px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.personal_allowance_ytd)}</td>
    </tr>

    <tr>
      <td style="padding:5px 10px; margin:6px auto;">Children Education Allowance</td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.child_edu)}</td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.paid_child_edu)}</td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.child_edu_arrear)}</td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.total_children)}</td>
      <td style="padding:5px 10px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.child_edu_ytd)}</td>
    </tr>

    <tr>
      <td style="padding:5px 10px; margin:6px auto;">Prev. Mth. Arrears</td>
      <td></td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.prev_month_arrears)}</td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.prev_month_arrears)}</td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.prev_month_arrears)}</td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.prev_month_arrears)}</td>
    </tr>

    <tr style="font-weight:700;">
      <td style="padding:5px 10px; margin:6px auto;">Total Earnings</td>
      <td></td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.paid_gross)}</td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.arrear)}</td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.total_earning)}</td>
      <td style="padding:5px 10px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.total_earning_ytd)}</td>
    </tr>

     <tr>
      <td style="padding:7px 0;"></td>
    </tr>
    
    <tr style="background:#f3f4f6;font-size:14px;">
      <td colspan="6" style="padding:5px 10px; text-align:left;width:140px;font-weight:700">Other Earnings (C)</td>
    </tr>

    <!-- <tr>
      <td style="padding:5px 0px; margin:6px auto;">Leave Encashment</td>
      <td colspan="3"></td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.leave_encashment)}</td>
      <td></td>
    </tr> -->

     <tr>
      <td style="padding:5px 10px; margin:6px auto;">Variable Pay</td>
      <td></td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.PaidVariablePay)}</td>
      <td></td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.TotalVariablePay)}</td>
      <td></td>
    </tr>
    <tr>
      <td style="padding:5px 10px; margin:6px auto;">Bonus</td>
      <td></td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.PaidBonus)}</td>
      <td></td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.TotalBonus)}</td>
      <td></td>
    </tr>
    
    <tr style="font-weight: 700;">
      <td style="padding:5px 10px; margin:6px auto;">Net Earnings(E=A+C)</td>
      <td colspan="3"></td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.total_earning)}</td>
      <td></td>
    </tr>
    <tr style="font-weight: 700;">
      <td style="padding:5px 10px; margin:6px auto;">Net Pay(E-F)</td>
      <td colspan="3"></td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.net_payable)}</td>
      <td></td>
    </tr>
  </tbody>
</table>
</div>

<!-- Deductions Table -->
<div style="width:100%;overflow-x:auto;display:block;margin-top:10px;">
<table style="min-width:600px;width:max-content;max-width:750px;border-collapse:collapse;">
  <thead>
   <tr style="font-size:14px; font-weight:600;">
      <th style="padding:5px 0px; text-align:left;width:180px; padding-bottom:11px;">Deductions (B)</th>
    </tr>
   <tr style="background:#f3f4f6;">
        <th style="padding:5px 10px; text-align:left;min-width:190px;">Component</th>
        <th style="padding:5px 0px; text-align:right;min-width:90px">Actual</th>
        <th style="padding:5px 0px; text-align:right;min-width:90px"></th>
        <th style="padding:5px 0px; text-align:right;min-width:90px">Arrear</th>
        <th style="padding:5px 0px; text-align:right;min-width:90px">Total</th>
        <th style="padding:5px 10px; text-align:right;min-width:110px">YTD</th>
      </tr>
    </tr>
  </thead>

  <tbody style="font-size:0.76rem;">
    <tr>
      <td style="padding:5px 10px; margin:6px auto;text-align:left;">PF (Employee Contribution)</td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.epf)}</td>
      <td></td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.epf_arrear)}</td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.total_pf)}</td>
      <td style="padding:5px 10px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.epf_ytd)}</td>
    </tr>
    
     <tr>
      <td style="padding:5px 10px; margin:6px auto;text-align:left;">Income Tax</td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.incomeTaxActual)}</td>
      <td></td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.incomeTaxArrear)}</td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.incomeTaxTotal)}</td>
      <td style="padding:5px 10px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.incomeTaxYTD)}</td>
    </tr>

    <!-- <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.total_medical_ins)}</td> -->
    <!--  <tr>
      <td style="padding:5px 10px; margin:6px auto;text-align:left;">Medical Deduction</td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.medical_insurance)}</td>
      <td></td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.medical_insurance_arrear)}</td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.medical_insurance)}</td>
      <td style="padding:5px 10px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.medical_insurance_ytd)}</td>
    </tr> -->

    <tr>
      <td style="padding:5px 10px; margin:6px auto;">Others Deduction</td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.esic)}</td>
      <td></td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.other_deduction_arrear)}</td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.total_deduction)}</td>
      <td style="padding:5px 10px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.other_deduction_ytd)}</td>
    </tr>

    <tr>
      <td style="padding:7px 0;"></td>
    </tr>
  
    <tr style="background:#f3f4f6;font-size:14px;">
      <td colspan="6" style="padding:8px 10px; text-align:left;width:150px;font-weight:700">Other Deductions (D)</td>
    </tr>
    <tr>
      <td style="padding:5px 10px; margin:6px auto;">Loan</td>
      <td colspan="3"></td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.loan)}</td>
      <td></td>
    </tr>
    <tr>
      <td style="padding:5px 10px; margin:6px auto;">Advance</td>
      <td colspan="3"></td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.advance)}</td>
      <td></td>
    </tr>

     <tr>
      <td style="padding:5px 10px; margin:6px auto;">Medical</td>
      <td colspan="3"></td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${salaryData.medical_insurance || 0}</td>
      <!-- <td style="padding:5px 0px; margin:6px auto;text-align:right;">${salaryData.total_medical_ins || 0}</td> -->
      <td></td>
    </tr>

    <tr style="font-weight: 700;">
      <td style="padding:5px 10px; margin:6px auto;">Net Deductions(F=B+D)</td>
      <td colspan="3"></td>
      <td style="padding:5px 0px; margin:6px auto;text-align:right;">${formattedAmount(salaryData?.total_deduction)}</td>
      <td></td>
    </tr>    
  </tbody>
</table>
</div>

  <!-- Footer -->
  <p style="text-align:center; margin-top:40px; font-size:11px;">
    This is a system generated payslip
  </p>
</div>`;
};
// --------------------------------
// export const sequence_allowance = [
//   "basic",
//   "special allowance",
//   "house rent allowance",
//   "children education allowance",
//   "prev. mth. arrears",
//   // "leave encashment",
//   "total earnings",
// ];
// export const allowance_data = [
//   {
//     allowance: "Basic",
//     actual: 30000,
//     paid: 28000,
//     arrear: 2000,
//     total: 30000,
//     ytd: 113851,
//   },
//   {
//     allowance: "House Rent Allowance",
//     actual: 15000,
//     paid: 14000,
//     arrear: 1000,
//     total: 15000,
//     ytd: 56926,
//   },
//   {
//     allowance: "Total Earnings",
//     actual: null,
//     paid: 69754,
//     arrear: 0,
//     total: 69754,
//     ytd: 255258,
//   },
//   {
//     allowance: "Children Education Allowance",
//     actual: 2000,
//     paid: 2000,
//     arrear: 0,
//     total: 2000,
//     ytd: 56983,
//   },
//   {
//     allowance: "Prev. Mth. Arrears",
//     actual: null,
//     paid: 27555,
//     arrear: 0,
//     total: 27555,
//     ytd: 27555,
//   },
//   {
//     allowance: "Special Allowance",
//     actual: 10000,
//     paid: 9000,
//     arrear: 1000,
//     total: 10000,
//     ytd: 56363,
//   },
//   // {
//   //   allowance: "Leave Encashment",
//   //   actual: null,
//   //   paid: 0,
//   //   arrear: null,
//   //   total: 0,
//   //   ytd: null,
//   // },
// ];

// export const getTableData = (sequenceArray: string[], data: any[]) => {
//   return sequenceArray?.map((str: string) =>
//     data?.find((itm: any) => itm.allowance?.toLowerCase() == str),
//   );
// };
